import {defineStore} from 'pinia'
import {CommonNs, ProjectNs} from "@shared/types";
import {ProjectApi} from "@/api";


export const useProjectStore = defineStore("project", {
  state: () => ({
    trashedProjectList: [] as ProjectNs.Project[],
    trashedProjectCount: 0
  }),
  getters: {
    getTrashedProjectList: (state): ProjectNs.Project[] => state.trashedProjectList,
    getTrashedProjectCount: (state): number => state.trashedProjectCount
  },
  actions: {
    async loadProject(projectId: string): Promise<ProjectNs.Project> {
      return ProjectApi.getProject(projectId).then((project) => project)
    },

    async loadAllProjectsInWorkspace(
        payload: ProjectNs.GetProjectsInWorkspaceRequest
    ): Promise<ProjectNs.Project[]> {
      return ProjectApi.getAllProjectsInWorkspace(payload)
      .then((allProjects) => allProjects)
    },

    async loadUserProjectsInWorkspace(
        payload: ProjectNs.GetUserProjectsInWorkspaceRequest
    ): Promise<ProjectNs.Project[]> {
      return ProjectApi.getUserProjectsInWorkspace(payload)
      .then((allProjects) => allProjects)
    },

    async loadProjectMembers(
        payload: ProjectNs.GetProjectMembersRequest
    ): Promise<ProjectNs.Member[]> {
      return ProjectApi.getProjectMemberList(payload)
      .then((projectMembers) => projectMembers)
    },

    async addProject(
        payload: ProjectNs.AddProjectRequest
    ): Promise<ProjectNs.AddProjectResponse> {
      return ProjectApi.addProject(payload)
      .then((projectResponse) => projectResponse)
    },

    async moveProject(
        payload: ProjectNs.MoveProjectRequest
    ): Promise<CommonNs.GenericResponse> {
      return ProjectApi.moveProject(payload)
      .then((response) => response)
    },

    async deleteProject(
        payload: ProjectNs.GenericProjectRequest
    ): Promise<CommonNs.GenericResponse> {
      return ProjectApi.deleteProject(payload)
      .then((response: any) => {
        this.trashedProjectCount = response.projectsInTrash
        return response;
      })
    },

    async deleteProjectPermanently(
        payload: ProjectNs.GenericProjectRequest
    ): Promise<ProjectNs.Project[]> {
      return ProjectApi.deletePermanentlyProject(payload)
      .then((response) => {
        this.trashedProjectList = response;
        this.trashedProjectCount = response.length
        return response;
      })
    },

    async restoreProject(
        payload: ProjectNs.GenericProjectRequest
    ): Promise<ProjectNs.Project[]> {
      return ProjectApi.restoreProject(payload)
      .then((response) => {
        this.trashedProjectList = response;
        this.trashedProjectCount = response.length
        return response;
      })
    },

    async loadProjectsFromTrash(
        payload: ProjectNs.GetProjectFromTrashRequest
    ): Promise<ProjectNs.Project[]> {
      return ProjectApi.getProjectsFromTrash(payload)
      .then((response) => {
        this.trashedProjectList = response;
        this.trashedProjectCount = response.length
        return response;
      })
    },

    async loadTrashedProjectCount(
        payload: ProjectNs.GetProjectFromTrashRequest
    ): Promise<number> {
      return ProjectApi.getTrashedProjectCount(payload).then((response) => {
        this.trashedProjectCount = response;
        return response;
      })
    },

  }
});
